import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './maintenance-property.module.scss';

interface MaintenancePropertyProps {
  hasProperty: boolean;
  className?: string;
}

export default function MaintenanceProperty({ hasProperty, className }: MaintenancePropertyProps) {
  const { t } = useTranslation('common');

  return (
    <div className={clsx(className, styles.chipContainer)}>
      {hasProperty ? t('states.yes') : t('states.no')}
    </div>
  );
}
